import { Job } from '../models/job.model';
export class AddJob {
    static readonly type = '[Job] Add';

    constructor(public payload: Job) {}
}

export class UpdateJobList {
    static readonly type = '[Job] Update list';

    constructor(public payload: Job[]) {}
}

export class RemoveJob {
    static readonly type = '[Job] Remove';

    constructor(public payload: Job) {}
}

export class ClearJob {
    static readonly type = '[Job] Clear';

    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/actions/job.action.ts